import { FC } from 'react';
import { ViewerModePillButton, ViewerModePillContainer } from '../styles';

export type ViewerMode = 'document' | 'xray' | 'list_checks';

interface ViewerModePillProps {
  mode: ViewerMode;
  showXray: boolean;
  showListChecks: boolean;
  onChange: (mode: ViewerMode) => void;
}

const ViewerModePill: FC<ViewerModePillProps> = ({ mode, showXray, showListChecks, onChange }) => (
  <ViewerModePillContainer role="group" aria-label="Viewer mode">
    <ViewerModePillButton
      type="button"
      id="viewer-mode-document"
      data-testid="viewer-mode-document"
      $active={mode === 'document'}
      aria-pressed={mode === 'document'}
      onClick={() => onChange('document')}
    >
      Document
    </ViewerModePillButton>
    {showXray && (
      <ViewerModePillButton
        type="button"
        id="viewer-mode-xray"
        data-testid="viewer-mode-xray"
        $active={mode === 'xray'}
        aria-pressed={mode === 'xray'}
        onClick={() => onChange('xray')}
      >
        X-Ray
      </ViewerModePillButton>
    )}
    {showListChecks && (
      <ViewerModePillButton
        type="button"
        id="viewer-mode-list-checks"
        data-testid="viewer-mode-list-checks"
        $active={mode === 'list_checks'}
        aria-pressed={mode === 'list_checks'}
        onClick={() => onChange('list_checks')}
      >
        List checks
      </ViewerModePillButton>
    )}
  </ViewerModePillContainer>
);

export default ViewerModePill;
